if (process.env.NODE_ENV === "production") {
  module.exports = require("./cjs/core.production.min.js")
} else {
  module.exports = require("./cjs/core.development.js")
}



//////////////////
// WEBPACK FOOTER
// ./~/@lingui/react/~/@lingui/core/index.js
// module id = 377
// module chunks = 168707334958949